import { all, call, put, takeLatest } from 'redux-saga/effects'

import agent, { mocked } from 'agent'

import appMode from 'helpers/getAppMode'
import { exportSaga } from './export.sagas'

import * as actions from 'redux/actions/keywordGrossing.actions'

function* getKeywordGrossingSaga(params) {
  try {
    const { domainId, filters } = params.payload
    const request = appMode.share
      ? agent.Share.grossing
      : appMode.preview
      ? mocked.Domains.grossing
      : agent.Domains.grossing

    const body = yield call(request, domainId, filters)
    const grossing = body.data

    yield put(actions.getDomainKeywordGrossingSuccess(grossing, domainId))
  } catch (error) {
    yield put(actions.getDomainKeywordGrossingFailure(error))
  }
}

function* exportKeywordGrosingExcelSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'xls',
    request: agent.Keywords.exportGrossingExcel,
    requestShared: agent.Share.exportShareGrossingExcel
  })
}

function* exportKeywordGrosingCSVSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'csv',
    request: agent.Keywords.exportGrossingCSV,
    requestShared: agent.Share.exportShareGrossingCSV
  })
}

export default function* keywordGrossingSagas() {
  yield all([
    takeLatest(actions.getDomainKeywordGrossing.type, getKeywordGrossingSaga),
    takeLatest(actions.exportDomainKeywordGrosingExcel.type, exportKeywordGrosingExcelSaga),
    takeLatest(actions.exportDomainKeywordGrosingCSV.type, exportKeywordGrosingCSVSaga)
  ])
}
